"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActiveTabAnimationRight = exports.ActiveTabAnimationLeft = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = _interopRequireDefault(require("@airasia/phoenix-components/components/Text"));

var _Image = _interopRequireDefault(require("@airasia/phoenix-components/components/Image"));

var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _constant = require("@airasia/phoenix-components/components/Text/constant");

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _constant2 = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _constants = require("./constants");

var _tile = _interopRequireDefault(require("./tile.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ActiveTabAnimationRight = (0, _styledComponents.keyframes)(["0%{transform:translateX(+100%);}100%{transform:translateX(0);}"]);
exports.ActiveTabAnimationRight = ActiveTabAnimationRight;
var ActiveTabAnimationLeft = (0, _styledComponents.keyframes)(["0%{transform:translateX(-100%);}100%{transform:translateX(0);}"]);
exports.ActiveTabAnimationLeft = ActiveTabAnimationLeft;

var ActiveTabEffect = _styledComponents.default.div.withConfig({
  displayName: "Tile__ActiveTabEffect",
  componentId: "sc-36ntfl-0"
})(["position:absolute;left:0;z-index:1;width:100%;height:", ";bottom:", ";background:", ";border-radius:", " ", " ", " ", ";animation:", " 0.3s ease-in-out 0s 1;"], function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.itemFlexDirection === 'column' ? '-10px' : _constants.NO_MARGIN;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.space.micro;
}, function (props) {
  return props.theme.space.micro;
}, _constants.NO_MARGIN, _constants.NO_MARGIN, function (props) {
  return (// eslint-disable-next-line no-nested-ternary
    props.animationType === _constants.ANIMATION_TYPE.LTR ? ActiveTabAnimationRight : props.animationType === _constants.ANIMATION_TYPE.RTL ? ActiveTabAnimationLeft : null
  );
});

var DesktopContainer = _styledComponents.default.div.withConfig({
  displayName: "Tile__DesktopContainer",
  componentId: "sc-36ntfl-1"
})(["position:relative;display:inline-flex;align-items:center;height:", ";&:hover{cursor:pointer;}background:", ";border-radius:", " ", " ", " ", ";flex:1;padding:0 ", ";vertical-align:top;flex-direction:", ";"], function (props) {
  return props.theme.space.XLarge;
}, function (props) {
  return props.background ? props.theme.backgroundColor[props.background] : props.theme.backgroundColor.default;
}, function (props) {
  return props.isFirst ? props.theme.space.micro : _constants.NO_MARGIN;
}, function (props) {
  return props.isLast ? props.theme.space.micro : _constants.NO_MARGIN;
}, _constants.NO_MARGIN, _constants.NO_MARGIN, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.itemFlexDirection || 'row';
});

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "Tile__Wrapper",
  componentId: "sc-36ntfl-2"
})(["display:flex;align-items:center;margin:", ";"], function (props) {
  return props.itemFlexDirection === 'column' ? '9px 0' : '0';
});

var InnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tile__InnerWrapper",
  componentId: "sc-36ntfl-3"
})(["max-width:", ";word-wrap:break-word;margin-left:", ";"], function (props) {
  return props.maxWidthDesktop ? props.maxWidthDesktop : _constants.MAX_WIDTH_DESKTOP;
}, function (props) {
  return props.showIcon && props.showTitle && props.itemFlexDirection !== 'column' ? props.theme.space.small : _constants.NO_MARGIN;
});

var MobileContainer = _styledComponents.default.div.withConfig({
  displayName: "Tile__MobileContainer",
  componentId: "sc-36ntfl-4"
})(["display:inline-block;position:relative;text-align:center;background:", ";flex:", ";width:100%;", ""], function (props) {
  return props.background ? props.theme.backgroundColor[props.background] : props.theme.backgroundColor.default;
}, function (props) {
  return props.tileType in _constants.MOBILE_IMAGE_CONSTANTS ? _constants.MOBILE_IMAGE_CONSTANTS[props.tileType].MOBILE_CONTAINER_FLEX : 'none';
}, function (props) {
  return props.tileType === 'PRODUCT_TILE' && "display: grid;\n  grid-template-rows: 16px;\n  grid-row-gap: 2px;\n  justify-items: center;\n  align-content: baseline;\n  ";
});

var MobileWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tile__MobileWrapper",
  componentId: "sc-36ntfl-5"
})(["display:inline-block;margin-top:", ";"], function (props) {
  return props.showIcon ? props.theme.space.tiny : _constants.NO_MARGIN;
});

var MobileInnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tile__MobileInnerWrapper",
  componentId: "sc-36ntfl-6"
})(["max-width:", ";word-wrap:break-word;margin:0 auto;"], function (props) {
  return (// eslint-disable-next-line no-nested-ternary
    props.itemFlexDirection === 'column' ? 'unset' : // eslint-disable-next-line no-nested-ternary
    props.tileType === _constants.TILE_TYPES.BOTTOM_TILE ? _constants.MOBILE_IMAGE_CONSTANTS.BOTTOM_TILE.NONE : // eslint-disable-next-line no-nested-ternary
    props.maxWidthMobile ? props.maxWidthMobile : _constants.MAX_WIDTH_MOBILE
  );
});

var ArrowWrapper = _styledComponents.default.div.withConfig({
  displayName: "Tile__ArrowWrapper",
  componentId: "sc-36ntfl-7"
})(["display:flex;"]);

var TileLabelContainerForDesktop = _styledComponents.default.div.withConfig({
  displayName: "Tile__TileLabelContainerForDesktop",
  componentId: "sc-36ntfl-8"
})(["position:absolute;top:", ";left:0%;right:0%;margin:0 ", ";text-align:", ";"], function (props) {
  return props.itemFlexDirection === 'column' ? '-20px' : '-12px';
}, function (_ref) {
  var theme = _ref.theme;
  return theme.space.small;
}, function (props) {
  return props.itemFlexDirection === 'column' ? 'center' : 'left';
});

var TileLabelContainerForMobile = _styledComponents.default.div.withConfig({
  displayName: "Tile__TileLabelContainerForMobile",
  componentId: "sc-36ntfl-9"
})(["white-space:nowrap;"]);

var renderAttractLabel = function renderAttractLabel(attractText, theme) {
  return /*#__PURE__*/_react.default.createElement(_Label.default, {
    textLimit: _constants.LABEL_TEXT_LIMIT,
    theme: theme,
    textColor: _constants.LABEL_TEXT_COLOR,
    labelColor: _constants.LABEL_COLOR,
    accessible: false
  }, attractText);
};

var Desktop = function Desktop(props, showBorder, handleClick, ref, animationType) {
  var accessible = props.accessible,
      theme = props.theme,
      background = props.background,
      isFirst = props.isFirst,
      isLast = props.isLast,
      maxWidthDesktop = props.maxWidthDesktop,
      data = props.data,
      customProperties = props.customProperties,
      showArrow = props.showArrow,
      textColor = props.textColor,
      idConfig = props.idConfig,
      itemFlexDirection = props.itemFlexDirection,
      tileImageDesktopWidth = props.tileImageDesktopWidth,
      tileImageDesktopHeight = props.tileImageDesktopHeight;

  var _ref2 = idConfig || {},
      widgetName = _ref2.widgetName,
      parentName = _ref2.parentName,
      index = _ref2.index;

  var _useState = (0, _react.useState)('tile'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      dynamicID = _useState2[0],
      setId = _useState2[1];

  (0, _react.useEffect)(function () {
    var url = 'tile';

    if (parentName) {
      url = "".concat(parentName, "-tile");
    }

    if (index) {
      url += "-".concat(index);
    }

    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }

    setId(url);
  }, [widgetName, parentName, index]);

  var _ref3 = data || {},
      iconUrl = _ref3.iconUrl,
      productTile = _ref3.productTile,
      attractText = _ref3.attractText;

  var showIcon = !!iconUrl;
  var showTitle = !!productTile;
  var tabIndex = !accessible ? '-1' : '0';
  var imageBackground = background || 'default';
  var tileLabelFontSize = itemFlexDirection === 'column' ? _constant.TEXT_TYPE.sub.type : _constant.TEXT_TYPE.default.type;
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(DesktopContainer, (0, _extends2.default)({
    id: dynamicID,
    onClick: function onClick(e) {
      return handleClick(e);
    },
    onKeyDown: function onKeyDown(e) {
      return _utilities.default.keyDownHandler(e, function () {
        return handleClick(e, true);
      }, _constant2.KEY_CODE.ENTER);
    },
    ref: ref,
    background: background,
    showBorder: showBorder,
    isFirst: isFirst,
    isLast: isLast,
    tabIndex: tabIndex,
    itemFlexDirection: itemFlexDirection
  }, customProperties), attractText && /*#__PURE__*/_react.default.createElement(TileLabelContainerForDesktop, {
    itemFlexDirection: itemFlexDirection
  }, renderAttractLabel(attractText, theme)), showBorder && itemFlexDirection !== 'column' && /*#__PURE__*/_react.default.createElement(ActiveTabEffect, {
    animationType: animationType
  }), /*#__PURE__*/_react.default.createElement(Wrapper, {
    showTitle: showTitle,
    itemFlexDirection: itemFlexDirection
  }, showIcon && /*#__PURE__*/_react.default.createElement(_Image.default, {
    theme: theme,
    height: tileImageDesktopHeight || _constants.DESKTOP_IMAGE_CONSTANTS.HEIGHT,
    width: tileImageDesktopWidth || _constants.DESKTOP_IMAGE_CONSTANTS.WIDTH,
    src: iconUrl,
    placeHolderBackground: imageBackground,
    accessible: false,
    alt: productTile,
    lazyLoadImage: false
  })), /*#__PURE__*/_react.default.createElement(InnerWrapper, {
    showTitle: showTitle,
    showIcon: showIcon,
    maxWidthDesktop: maxWidthDesktop,
    itemFlexDirection: itemFlexDirection,
    className: "tile-inner-wrapper"
  }, showTitle && /*#__PURE__*/_react.default.createElement(_Text.default, {
    theme: theme,
    type: tileLabelFontSize,
    color: textColor,
    accessible: false
  }, productTile)), showArrow && /*#__PURE__*/_react.default.createElement(ArrowWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: _constants.ARROW_TYPE,
    fontsize: _constants.ICON_FONT_SIZE,
    color: textColor
  }))));
};

Desktop.propTypes = _tile.default.PropTypes;

var Mobile = function Mobile(props, handleClick) {
  var accessible = props.accessible,
      theme = props.theme,
      background = props.background,
      data = props.data,
      maxWidthMobile = props.maxWidthMobile,
      textColor = props.textColor,
      customProperties = props.customProperties,
      tileType = props.tileType,
      idConfig = props.idConfig,
      itemFlexDirection = props.itemFlexDirection,
      tileImageMobileWidth = props.tileImageMobileWidth,
      tileImageMobileHeight = props.tileImageMobileHeight;

  var _ref4 = data || {},
      iconUrl = _ref4.iconUrl,
      productTile = _ref4.productTile,
      attractText = _ref4.attractText;

  var showIcon = !!iconUrl;
  var showTitle = !!productTile;
  var tabIndex = !accessible ? '-1' : '0';
  var imageBackground = background || 'default';

  var _ref5 = idConfig || {},
      parentName = _ref5.parentName,
      widgetName = _ref5.widgetName,
      index = _ref5.index;

  var _useState3 = (0, _react.useState)('tile'),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      dynamicID = _useState4[0],
      setId = _useState4[1];

  var tileLabelFontSize = itemFlexDirection === 'column' ? _constant.TEXT_TYPE.textSmall.type : _constant.TEXT_TYPE.small.type;
  (0, _react.useEffect)(function () {
    var url = 'tile';

    if (parentName) {
      url = "".concat(parentName, "-tile");
    }

    if (index) {
      url += "-".concat(index);
    }

    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }

    setId(url);
  }, [widgetName, parentName, index]);
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(MobileContainer, (0, _extends2.default)({
    id: dynamicID,
    background: background,
    tabIndex: tabIndex,
    tileType: tileType
  }, customProperties, {
    onClick: function onClick(e) {
      return handleClick(e);
    }
  }), /*#__PURE__*/_react.default.createElement(TileLabelContainerForMobile, null, attractText && renderAttractLabel(attractText, theme)), /*#__PURE__*/_react.default.createElement(MobileWrapper, {
    showIcon: showIcon,
    showTitle: showTitle
  }, showIcon && /*#__PURE__*/_react.default.createElement(_Image.default, {
    theme: theme,
    height: tileImageMobileHeight || (tileType in _constants.MOBILE_IMAGE_CONSTANTS ? _constants.MOBILE_IMAGE_CONSTANTS[tileType].HEIGHT : _constants.MOBILE_IMAGE_CONSTANTS.PRODUCT_TILE.HEIGHT),
    width: tileImageMobileWidth || (tileType in _constants.MOBILE_IMAGE_CONSTANTS ? _constants.MOBILE_IMAGE_CONSTANTS[tileType].WIDTH : _constants.MOBILE_IMAGE_CONSTANTS.PRODUCT_TILE.WIDTH),
    src: iconUrl,
    lazyLoadImage: false,
    placeHolderBackground: imageBackground,
    alt: productTile
  })), /*#__PURE__*/_react.default.createElement(MobileInnerWrapper, {
    showIcon: showIcon,
    showTitle: showTitle,
    maxWidthMobile: maxWidthMobile,
    tileType: tileType
  }, showTitle && /*#__PURE__*/_react.default.createElement(_Text.default, {
    theme: theme,
    type: tileLabelFontSize,
    textAlign: _constants.TEXT_ALIGN,
    color: textColor
  }, productTile))));
};

Mobile.propTypes = _tile.default.PropTypes;

var widgetCallBack = function widgetCallBack(widgetFunction, productID, cnDisclaimerLine1) {
  if (widgetFunction) {
    return cnDisclaimerLine1 ? widgetFunction(false, productID) : widgetFunction(true, productID);
  }

  return null;
};

var redirectionAction = function redirectionAction(newTab, redirectionUrl) {
  if (newTab === 'TRUE') {
    window.open(redirectionUrl);
  } else {
    window.location.replace(redirectionUrl);
  }
};

var Tile = function Tile(props) {
  var index = props.index,
      data = props.data,
      gtmParameters = props.gtmParameters,
      handleGtm = props.handleGtm,
      isMobile = props.isMobile,
      widgetFunction = props.widgetFunction,
      deviceType = props.deviceType,
      animationType = props.animationType,
      highlightTileByDeFaultId = props.highlightTileByDeFaultId,
      queryParamsPresent = props.queryParamsPresent,
      shouldFireGTM = props.shouldFireGTM;
  var showSearchWidget = data.showSearchWidget,
      redirectionUrl = data.redirectionUrl,
      newTab = data.newTab,
      productID = data.productID,
      cnDisclaimerLine1 = data.cnDisclaimerLine1,
      showSearchWidgetMobile = data.showSearchWidgetMobile,
      onClick = data.onClick,
      attractText = data.attractText;
  var _data$gtmProductID = data.gtmProductID,
      gtmProductID = _data$gtmProductID === void 0 ? '' : _data$gtmProductID;

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      showBorder = _useState6[0],
      setShowBorder = _useState6[1];

  var _useState7 = (0, _react.useState)(0),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      count = _useState8[0],
      setCount = _useState8[1];

  var ref = (0, _react.useRef)(null);
  var currentAnimation = null;
  var version = props.version.toLowerCase();

  var prepareAndFireGtm = function prepareAndFireGtm(ProductID, position, promotionLabel) {
    var eventLabelTileClick = gtmParameters ? gtmParameters.replace('{{productid}}', ProductID || null).replace('{{producttilesposition}}', position || null).replace('{{promotionlabel}}', promotionLabel || null) : null; // eslint-disable-next-line no-unused-expressions

    eventLabelTileClick && handleGtm ? handleGtm(productID, eventLabelTileClick, true) : null;
  };

  var sendBackProductData = function sendBackProductData() {
    props.getProductData(data);
  }; // eslint-disable-next-line react-hooks/exhaustive-deps


  var visibilityChange = function visibilityChange() {
    if (!isMobile && showBorder) {
      setShowBorder(!showBorder);
      setCount(0);
    }
  };

  var handleClick = onClick || function (e) {
    var isKeyDown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (shouldFireGTM) prepareAndFireGtm(gtmProductID || productID, index, attractText);
    setCount(count + 1);

    if (showSearchWidget === 'TRUE') {
      if (showSearchWidgetMobile === 'FALSE') {
        if (deviceType === _constant2.DEVICE_TYPE.MOBILE || deviceType === _constant2.DEVICE_TYPE.TABLET) {
          redirectionAction(newTab, redirectionUrl);
        } else {
          sendBackProductData();
          widgetCallBack(widgetFunction, productID, null);
        }
      } else {
        sendBackProductData();
        widgetCallBack(widgetFunction, productID, null);
      }

      if (version === 'v2' && !showBorder && !isMobile) {
        setShowBorder(!showBorder);
      }

      if (typeof document !== 'undefined' && isKeyDown) {
        _utilities.default.elementReady('.showTray [tabindex="0"]').then(function (el) {
          el.focus();
          var tray = document.querySelector('.showTray');

          if (tray) {
            var trayFocusout = function trayFocusout(ev) {
              if (!tray.contains(ev.relatedTarget || ev.target)) {
                if (ref.current.nextSibling) {
                  ref.current.nextSibling.focus();
                  setShowBorder(false);
                  setCount(0);
                  tray.removeEventListener('focusout', trayFocusout);
                }
              }
            };

            tray.addEventListener('focusout', trayFocusout);
          }
        });
      }
    } else if (cnDisclaimerLine1) {
      widgetCallBack(widgetFunction, productID, cnDisclaimerLine1);
    } else if (redirectionUrl) {
      redirectionAction(newTab, redirectionUrl);
    }

    if (version === 'v1' && !showBorder && !isMobile) {
      setShowBorder(!showBorder);
    }
  };

  currentAnimation = count > 1 ? _constants.ANIMATION_TYPE.noAnimation : animationType; // eslint-disable-next-line react-hooks/exhaustive-deps

  var handleClickOutside = (0, _react.useCallback)(function (event) {
    var tray = null;

    if (typeof document !== 'undefined') {
      tray = document.querySelector('.showTray');
    }

    if (!isMobile && showBorder && ref.current && event && !ref.current.contains(event.target)) {
      if (!tray || tray && !tray.contains(event.target)) {
        setShowBorder(!showBorder);
        setCount(0);
      }
    }
  });
  (0, _react.useEffect)(function () {
    if (typeof document !== 'undefined') {
      if (version === 'v1') {
        document.addEventListener('click', function (e) {
          return handleClickOutside(e);
        });
        document.addEventListener('visibilitychange', visibilityChange);
        document.addEventListener('keydown', function (e) {
          return _utilities.default.keyDownHandler(e, function () {
            return handleClickOutside(e);
          }, _constant2.KEY_CODE.ENTER);
        });
      }
    }

    return function () {
      if (typeof document !== 'undefined') {
        if (version === 'v1') {
          document.removeEventListener('click', function (e) {
            return handleClickOutside(e);
          });
          document.removeEventListener('visibilitychange', visibilityChange);
          document.removeEventListener('keydown', function (e) {
            return _utilities.default.keyDownHandler(e, function () {
              return handleClickOutside(e);
            }, _constant2.KEY_CODE.ENTER);
          });
        }
      }
    };
  }, [handleClickOutside, visibilityChange, version]);
  (0, _react.useEffect)(function () {
    if ((version === 'v2' || queryParamsPresent) && highlightTileByDeFaultId === productID) setShowBorder(true);else setShowBorder(false);
  }, [queryParamsPresent, highlightTileByDeFaultId, productID, version]);
  return isMobile ? Mobile(props, handleClick) : Desktop(props, showBorder, handleClick, ref, currentAnimation);
};

Tile.propTypes = _tile.default.PropTypes;
Tile.defaultProps = _tile.default.defaultProps;
var _default = Tile;
exports.default = _default;